<template>
  <div>
    <v-card>
      <v-tabs
        v-model="active_tab"
        show-arrows
        icons-and-text
        mb-5
        dark
        background-color="indigo darken-1"
      >
        <v-tab
          key="uvod"
          :to="uvod"
          @click="getForms"
        >
          Základné údaje
          <v-icon>mdi-book</v-icon>
        </v-tab>
        <v-tab
          v-if="canSee_rizikove_faktory"
          key="rizikove_faktory"
          :to="rizikove_faktory"
          @click="getForms"
        >
          Rizikové faktory
          <v-icon>{{ icon_rizikove_faktory }}</v-icon>
        </v-tab>
        <v-tab
          v-if="canSee_penitenciarne_zaobchadzanie"
          key="penitenciarne_zaobchadzanie"
          :to="penitenciarne_zaobchadzanie"
          @click="getForms"
        >
          Penitenciárne zaobchádzanie a kompetencie
          <v-icon>{{ icon_penitenciarne_zaobchadzanie }}</v-icon>
        </v-tab>
        <v-tab
          v-if="canSee_psychologicke_vysetrenie"
          key="psychologicke_vysetrenie"
          :to="psychologicke_vysetrenie"
          @click="getForms"
        >
          Psychologické vyšetrenie
          <v-icon>{{ icon_psychologicke_vysetrenie }}</v-icon>
        </v-tab>
        <v-tab
          v-if="canSee_poznatky_pbs"
          key="poznatky_pbs"
          :to="poznatky_pbs"
          @click="getForms"
        >
          PBS
          <v-icon>{{ icon_poznatky_pbs }}</v-icon>
        </v-tab>
        <v-tab
          v-if="canSee_nahodne_overenie && item.version == 1"
          key="nahodne_overenie"
          :to="nahodne_overenie"
          @click="getForms"
        >
          Náhodné overenie
          <v-icon>{{ icon_nahodne_overenie }}</v-icon>
        </v-tab>
        <v-tab
          v-if="canSee_socialny_kurator"
          key="socialny_kurator"
          :to="socialny_kurator"
          @click="getForms"
        >
          Sociálny kurátor
          <v-icon>{{ icon_socialny_kurator }}</v-icon>
        </v-tab>
        <v-tab
          v-if="canSee_zaver"
          key="zaver"
          :to="zaver"
          @click="getForms"
        >
          Záver
          <v-icon>{{ icon_zaver }}</v-icon>
        </v-tab>
        <v-tab
          v-if="canSee_admin"
          key="admin"
          :to="admin"
          @click="getForms"
        >
          Administrácia
          <v-icon>mdi-gauge</v-icon>
        </v-tab>
      </v-tabs>
    </v-card>
    <div class="px-5 py-3">
      <v-card shaped>
        <v-card-title>
          {{ item.prisoner_full.string_details }}
        </v-card-title>
        <v-card-text>
          <router-view />
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import { APIService } from "@/http/APIService.js";
import { mapGetters } from "vuex";

const apiService = new APIService();

export default {

  data() {
    return {
      active_tab: "uvod",
      headline: "",

      permissions: {
        cra: { view: false },
        rizikove_faktory: { view: false },
        penitenciarne_zaobchadzanie: { view: false },
        psychologicke_vysetrenie: { view: false },
        poznatky_pbs: { view: false },
        nahodne_overenie: { view: false },
        socialny_kurator: { view: false },
        is_superuser: false,
      },
      item: {
        rizikove_faktory_full: {
          closed: false,
        },
        penitenciarne_zaobchadzanie_full: {
          closed: false,
        },
        psychologicke_vysetrenie_full: {
          closed: false,
        },
        poznatky_pbs_full: {
          closed: false,
        },
        nahodne_overenie_full: {
          closed: false,
        },
        socialny_kurator_full: {
          closed: false,
        },
        prisoner_full: {
          string_details: "",
        },
        closed: false,
      },
    };
  },
  mounted() {
    this.getForms();

    this.$root.$on("ecra_part_updated", () => {
      this.getForms();
    });
  },

  computed: {
    ...mapGetters("auth", ["username"]),

    uvod() {
      return "/crcra/" + this.$route.params.id + `/uvod_v${this.item.version}`;
    },

    rizikove_faktory() {
      return (
        "/crcra/" +
        this.$route.params.id +
        `/rizikove_faktory_v${this.item.version}`
      );
    },

    penitenciarne_zaobchadzanie() {
      return (
        "/crcra/" +
        this.$route.params.id +
        `/penitenciarne_zaobchadzanie_v${this.item.version}`
      );
    },

    psychologicke_vysetrenie() {
      return (
        "/crcra/" +
        this.$route.params.id +
        `/psychologicke_vysetrenie_v${this.item.version}`
      );
    },

    poznatky_pbs() {
      return (
        "/crcra/" +
        this.$route.params.id +
        `/poznatky_pbs_v${this.item.version}`
      );
    },
    nahodne_overenie() {
      return (
        "/crcra/" +
        this.$route.params.id +
        `/nahodne_overenie_v${this.item.version}`
      );
    },
    socialny_kurator() {
      return (
        "/crcra/" +
        this.$route.params.id +
        `/socialny_kurator_v${this.item.version}`
      );
    },

    zaver() {
      return "/crcra/" + this.$route.params.id + `/zaver_v${this.item.version}`;
    },

    admin() {
      return "/crcra/" + this.$route.params.id + `/admin_v${this.item.version}`;
    },

    canSee_rizikove_faktory() {
      return this.permissions.rizikove_faktory.view;
    },
    canSee_penitenciarne_zaobchadzanie() {
      return this.permissions.penitenciarne_zaobchadzanie.view;
    },
    canSee_psychologicke_vysetrenie() {
      return this.permissions.psychologicke_vysetrenie.view;
    },
    canSee_poznatky_pbs() {
      return this.permissions.poznatky_pbs.view;
    },
    canSee_nahodne_overenie() {
      return this.permissions.nahodne_overenie.view;
    },
    canSee_socialny_kurator() {
      if (this.item.type == "CR") return false;

      return this.permissions.socialny_kurator.view;
    },
    canSee_zaver() {
      if (this.permissions.is_superuser) return true;

      return this.item.closed;
    },
    canSee_admin() {
      return this.permissions.cra.change;
    },

    icon_rizikove_faktory() {
      return this.item.rizikove_faktory_full.closed
        ? "mdi-lock"
        : "mdi-lock-open-variant";
    },
    icon_penitenciarne_zaobchadzanie() {
      return this.item.penitenciarne_zaobchadzanie_full.closed
        ? "mdi-lock"
        : "mdi-lock-open-variant";
    },

    icon_psychologicke_vysetrenie() {
      return this.item.psychologicke_vysetrenie_full.closed
        ? "mdi-lock"
        : "mdi-lock-open-variant";
    },
    icon_poznatky_pbs() {
      return this.item.poznatky_pbs_full.closed
        ? "mdi-lock"
        : "mdi-lock-open-variant";
    },
    icon_nahodne_overenie() {
      return this.item.nahodne_overenie_full.closed
        ? "mdi-lock"
        : "mdi-lock-open-variant";
    },
    icon_socialny_kurator() {
      return this.item.socialny_kurator_full.closed
        ? "mdi-lock"
        : "mdi-lock-open-variant";
    },
    icon_zaver() {
      return this.item.closed ? "mdi-lock" : "mdi-lock-open-variant";
    },
  },

  beforeDestroy() {
  },

  methods: {
    getForms() {
      apiService.getCraForm(this.$route.params.id).then((response) => {
        this.item = response;
      });
      apiService
        .getCraFormPermissions(this.$route.params.id)
        .then((response) => {
          this.permissions = response;
        });
    },
  },
};
</script>